import { useState, type FC } from "react";
import BrandLogo from "../../components/BrandLogo";
import { Button } from "../../components/ui/button";
import { gluceraAssessmentCta } from "../../utils/gluceraTypography";
import { Card } from "../../components/ui/card";
import RadioDot from "../../components/common/RadioDot";
import { useNavigate } from "react-router-dom";
import GluceraNavigationRoutes from "../../utils/navigationRoutes";
import SessionStorageHelper from "../../utils/sessionStorageHelper";

const Dietpage: FC = () => {
  const navigate = useNavigate();
  const [selectedDiet, setSelectedDiet] = useState<string>("");

  const diets = [
    { title: "Classic", value: "classic" },
    { title: "Vegetarian", value: "vegetarian" },
    { title: "Vegan", value: "vegan" },
    { title: "Pescatarian", value: "pescatarian" },
    { title: "Low Carb / Keto", value: "low_carb_keto" },
  ];

  return (
    <div className="h-screen w-screen overflow-hidden bg-background">
      <div className="mx-auto flex h-full w-full max-w-md flex-col">
        {/* Header */}
        <div className="space-y-4 px-4 pb-4 pt-safe">
          <BrandLogo />

          {/* Assessment Progress */}
          <p className="text-center text-subhead text-muted-foreground">
            Assessment 9 of 11
          </p>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto px-6 py-2 scrollbar-hide [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div className="mb-8 space-y-2">
            <h1 className="text-large-title font-bold text-foreground sm:text-4xl">
              Do You Follow A Specific Diet?
            </h1>
            <p className="text-subhead text-muted-foreground">
              Select your diet preference
            </p>
          </div>

          <div className="space-y-3">
            {diets.map(diet => (
              <Card
                key={diet.value}
                className={`cursor-pointer transition-all ${
                  selectedDiet === diet.value
                    ? "border border-primary bg-primary/5"
                    : "border border-border hover:border-primary/50"
                }`}
                onClick={() => setSelectedDiet(diet.value)}
              >
                <div className="flex items-center justify-between p-4">
                  <span className="text-title3 font-semibold text-foreground">
                    {diet.title}
                  </span>
                  <RadioDot selected={selectedDiet === diet.value} />
                </div>
              </Card>
            ))}
          </div>
        </div>

        {/* Footer Button */}
        <div className="pb-safe border-t p-4">
          <Button
            onClick={() => {
              if (selectedDiet) {
                SessionStorageHelper.saveField("diet_adherence", selectedDiet);
                // navigate("/glucera" + GluceraNavigationRoutes.EATMEALPAGE);
                navigate("/glucera" + GluceraNavigationRoutes.IntermittentFastingPage);
              }
            }}
            disabled={!selectedDiet}
            className={gluceraAssessmentCta}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Dietpage;
